// Custom mouse cursors for the drawing tools, as ready-to-use CSS `cursor`
// values (inline SVG data-URI + hotspot + a `crosshair` fallback). Single source
// of truth — reference CURSORS.pen / CURSORS.eraser, never inline an SVG in a
// component. The hotspot (hotX hotY) is the pixel in the image that maps to the
// actual pointer position: the pen's nib and the eraser's working corner.

const PEN_SVG =
  `<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>` +
  `<path d='M8.5 19 L18 9.5 L22.5 14 L13 23.5 Z' fill='#38bdf8' stroke='#0f172a' stroke-width='1.6' stroke-linejoin='round'/>` +
  `<path d='M18 9.5 L21 6.5 L25.5 11 L22.5 14 Z' fill='#cbd5e1' stroke='#0f172a' stroke-width='1.6' stroke-linejoin='round'/>` +
  `<path d='M8.5 19 L13 23.5 L6.5 25.5 Z' fill='#0f172a'/>` +
  `</svg>`;

const ERASER_SVG =
  `<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>` +
  `<g transform='rotate(-38 14 14)'>` +
  `<rect x='5' y='12' width='18' height='9' rx='2.5' fill='#f472b6' stroke='#0f172a' stroke-width='1.6'/>` +
  `<rect x='5' y='12' width='6' height='9' rx='2.5' fill='#fbcfe8' stroke='#0f172a' stroke-width='1.6'/>` +
  `</g>` +
  `</svg>`;

function toCursor(svg: string, hotX: number, hotY: number): string {
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${hotX} ${hotY}, crosshair`;
}

export const CURSORS = {
  pen: toCursor(PEN_SVG, 6, 25),
  eraser: toCursor(ERASER_SVG, 8, 20),
} as const;
